import { PulseLoader } from 'react-spinners';

export const Loader = () => {
  return <PulseLoader color="#964B00" size={12} speedMultiplier={1} />;
};
